/*
 * @Author: 黄斌旭
 * @Date: 2020-02-07 10:38:32
 * @LastEditors: DG
 * @LastEditTime: 2022-02-25 13:40:16
 * @Description: file content
 */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConfigProvider, message, notification } from 'antd';
import longan from 'longan-sdk';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import Store from './store';
import Routes from './routers/Routes';
import './appRegister';
import './index.less';

moment.locale('zh-cn');

message.config({
  prefixCls: 'smart-message',
});

notification.config({
  prefixCls: 'smart-notification',
});

ConfigProvider.config({
  prefixCls: 'smart',
});

longan.start({
  project_name: 'ts-smart', // 项目名称
  env: {
    online: 'ts-smart.sf-express.com',
    develop: window.location.host,
  },
  filter_error_msg: [
    'ResizeObserver loop',
    "'ptp_assist' died",
    "reading 'destroy'",
    "application 'ptp' died",
    "reading 'ciphertext'",
    'this.service.apply(...).then(...).catch(...).finally',
    'Object.values is not a function',
  ],
});

const App = () => (
  <ConfigProvider locale={zhCN} prefixCls="smart">
    <Provider store={Store}>
      <BrowserRouter>
        <Routes />
      </BrowserRouter>
    </Provider>
  </ConfigProvider>
);

export default App;
